import nonVSSpacesBase from "./nonVSSpacesBase";
import { ReportFeedbackGuidance, SpaceConfig } from "./spaceConfig";
import { SpaceId } from "./spaceIds";
import { UnknownSlugWorkaround } from "./spacesBase";

const additionalGuidance: ReportFeedbackGuidance = {
    title: 'C++ compiler bugs',
    iconName: 'CPlusPlus',
    description: "See <a href='https://aka.ms/compilerbug' target='_blank' rel='noopener noreferrer'>https://aka.ms/compilerbug</a> for more details on creating a compiler-bug repro."
};

const spaceCpp: SpaceConfig = {
    ...nonVSSpacesBase,
    id: SpaceId.Cpp,
    displayName: "C++",
    slug: UnknownSlugWorkaround,
    spaceTag: { type: "tag", value: "cppcompiler" },
    reportProblemConfig: {
        ...nonVSSpacesBase.reportProblemConfig,
        additionalGuidance: additionalGuidance,
    },
    reportSuggestionConfig: {
        ...nonVSSpacesBase.reportSuggestionConfig,
        additionalGuidance: additionalGuidance,
    },
};

export default spaceCpp;
